<template>
    <div v-if="statistics && statistics.length == 0" class="alert alert-warning">
        Kein Ergebnis
    </div>
    <div v-else >
        <div class="text-center">
            <div class="btn-group">
                <button
                    type="button"
                    class="btn"
                    @click="changeFormat('daily')"
                    v-b-tooltip.hover title="Täglich"
                    :class="{'btn-dark': format != 'daily', 'btn-success': format == 'daily'}">
                    T
                </button>
                <button
                    type="button"
                    class="btn"
                    @click="changeFormat('weekly')"
                    v-b-tooltip.hover title="Wöchentlich"
                    :class="{'btn-dark': format != 'weekly', 'btn-success': format == 'weekly'}">
                    W
                </button>
                <button
                    type="button"
                    class="btn"
                    @click="changeFormat('monthly')"
                    v-b-tooltip.hover title="Monatlich"
                    :class="{'btn-dark': format != 'monthly', 'btn-success': format == 'monthly'}">
                    M
                </button>
                <button
                    type="button"
                    class="btn"
                    @click="changeFormat('annually')"
                    v-b-tooltip.hover title="Jährlich"
                    :class="{'btn-dark': format != 'annually', 'btn-success': format == 'annually'}">
                    J
                </button>
            </div>
        </div>
        <div class="position-relative">
            <h5 class="mt-3">Aufrufe</h5>
            <loading-icon v-if="aufrufe_loading"></loading-icon>
            <div ref="aufrufe"  class="my-5 w-100 radius-size" style="min-height: 300px;"></div>
        </div>
        <div class="position-relative">
            <h5 class="mt-3">Anfragen</h5>
            <loading-icon v-if="anfragen_loading"></loading-icon>
            <div ref="anfragen" class="my-5 w-100" style="min-height: 300px;"></div>
        </div>
        <div class="position-relative">
            <h5 class="mt-3">Telefon</h5>
            <loading-icon v-if="telefon_loading"></loading-icon>
            <div ref="telefon"  class="my-5 w-100" style="min-height: 300px;"></div>
        </div>
    </div>
</template>

<script>
    import { GoogleCharts } from 'google-charts';

    export default {
        data() {
            return {
                aufrufe_loading: true,
                anfragen_loading: true,
                telefon_loading: true,
                statistics: [],
                stat_compared: [],
                compare: this.filters.dateCompare || (this.filters.period && this.filters.period['type_compare'] != '') ? true : false,
                format: 'daily'
            }
        },
        props: ['filters', 'date_ranges'],
        watch: {
            filters(val) {
                this.compare = val.dateCompare || (val.period && val.period['type_compare'] != '') ? true : false;
                this.fetchChartData();
            },
        },
        methods: {
            changeFormat(val) {
                if(this.format != val) {
                    this.format = val;
                    this.fetchChartData();
                }
            },
            fetchChartData() {

                this.$store.state.loading = true;
                this.$http.get('/StatisticsApi/getChartData', {
                    params: {
                        filters: this.filters,
                        format: this.format
                    }}).then(response => {
                    let data              = JSON.parse(response.data);
                    this.statistics       = data ? data : [];
                    console.log('this.statistics: '+this.statistics);
                    if(!(this.statistics.length === 0)){
                      console.log('this.statistics123: '+this.statistics);
                      this.aufrufe_loading  = true;
                      this.anfragen_loading = true;
                      this.telefon_loading  = true;
                      GoogleCharts.load(this.drawAufrufeChart,  {'packages':['line']});
                      GoogleCharts.load(this.drawAnfragenChart, {'packages':['line']});
                      GoogleCharts.load(this.drawTelefonChart,  {'packages':['line']});
                    }
                }).catch(error => {
                    console.log(error);
                }).then(() => { this.$store.state.loading = false; });
            },
            drawAufrufeChart() {
                const data = new GoogleCharts.api.visualization.DataTable();
                data.addColumn('string', 'Zeit');

                if(this.compare){
                    if(this.filters.date){
                        data.addColumn('number', this.$options.filters.date(this.filters.date.from )+ ' bis ' + this.$options.filters.date(this.filters.date.to));
                    }else if(this.filters.period){
                        if(this.date_ranges){
                            data.addColumn('number', this.date_ranges.start + ' bis ' + this.date_ranges.end);
                        }else{
                            data.addColumn('number', this.$t('intern_statistics.' + this.filters.period.type));
                        }
                    }
                    if(this.filters.dateCompare){
                        data.addColumn('number', this.$options.filters.date(this.filters.dateCompare.from) + ' bis ' + this.$options.filters.date(this.filters.dateCompare.to));
                    }else if(this.filters.period){
                        if(this.date_ranges){
                            data.addColumn('number', this.date_ranges.start_compare + ' bis ' + this.date_ranges.end_compare);
                        }else{
                            data.addColumn('number', this.$t('intern_statistics.' + this.filters.period.type_compare));
                        }
                    }
                }else {
                    data.addColumn('number', 'Aufrufe');
                }

                data.addRows(Object.keys(this.statistics).length);

                Object.keys(this.statistics).forEach( key => {
                    data.setValue(this.statistics[key].lfd, 0, this.statistics[key].show_date);
                    data.setValue(this.statistics[key].lfd, 1, Number(this.statistics[key].aufrufe));
                    if(this.compare){
                        data.setValue(this.statistics[key].lfd, 2, Number(this.statistics[key].aufrufe_compare));
                    }
                });

                const chart = new GoogleCharts.api.charts.Line(this.$refs.aufrufe);
                chart.draw(data, {
                    title: 'Aufrufe',
                    height: 400,
                    hAxis: {
                        title: 'Zeit'
                    },
                    vAxis: {
                        title: 'Aufrufe'
                    }
                });
                GoogleCharts.api.visualization.events.addListener(chart, 'ready', () => {
                    this.aufrufe_loading = false;
                });
            },
            drawAnfragenChart() {
                const data = new GoogleCharts.api.visualization.DataTable();
                data.addColumn('string', 'Zeit');

                if(this.compare){
                    if(this.filters.date){
                        data.addColumn('number', this.$options.filters.date(this.filters.date.from )+ ' bis ' + this.$options.filters.date(this.filters.date.to));
                    }else if(this.filters.period){
                        if(this.date_ranges){
                            data.addColumn('number', this.date_ranges.start + ' bis ' + this.date_ranges.end);
                        }else{
                            data.addColumn('number', this.$t('intern_statistics.' + this.filters.period.type));
                        }
                    }
                    if(this.filters.dateCompare){
                        data.addColumn('number', this.$options.filters.date(this.filters.dateCompare.from) + ' bis ' + this.$options.filters.date(this.filters.dateCompare.to));
                    }else if(this.filters.period){
                        if(this.date_ranges){
                            data.addColumn('number', this.date_ranges.start_compare + ' bis ' + this.date_ranges.end_compare);
                        }else{
                            data.addColumn('number', this.$t('intern_statistics.' + this.filters.period.type_compare));
                        }
                    }
                }else {
                    data.addColumn('number', 'Anfragen');
                }

                data.addRows(Object.keys(this.statistics).length);

                Object.keys(this.statistics).forEach( key => {
                    data.setValue(this.statistics[key].lfd, 0, this.statistics[key].show_date);
                    data.setValue(this.statistics[key].lfd, 1, Number(this.statistics[key].anfragen));
                    if(this.compare){
                        data.setValue(this.statistics[key].lfd, 2, Number(this.statistics[key].anfragen_compare));
                    }
                });

                const chart = new GoogleCharts.api.charts.Line(this.$refs.anfragen);
                chart.draw(data, {
                    title: 'Anfragen',
                    height: 400,
                    hAxis: {
                        title: 'Zeit'
                    },
                    vAxis: {
                        title: 'Anfragen'
                    },
                });
                GoogleCharts.api.visualization.events.addListener(chart, 'ready', () => {
                    this.anfragen_loading = false;
                });
            },
            drawTelefonChart() {
                const data = new GoogleCharts.api.visualization.DataTable();
                data.addColumn('string', 'Zeit');

                if(this.compare){
                    if(this.filters.date){
                        data.addColumn('number', this.$options.filters.date(this.filters.date.from )+ ' bis ' + this.$options.filters.date(this.filters.date.to));
                    }else if(this.filters.period){
                        if(this.date_ranges){
                            data.addColumn('number', this.date_ranges.start + ' bis ' + this.date_ranges.end);
                        }else{
                            data.addColumn('number', this.$t('intern_statistics.' + this.filters.period.type));
                        }
                    }
                    if(this.filters.dateCompare){
                        data.addColumn('number', this.$options.filters.date(this.filters.dateCompare.from) + ' bis ' + this.$options.filters.date(this.filters.dateCompare.to));
                    }else if(this.filters.period){
                        if(this.date_ranges){
                            data.addColumn('number', this.date_ranges.start_compare + ' bis ' + this.date_ranges.end_compare);
                        }else{
                            data.addColumn('number', this.$t('intern_statistics.' + this.filters.period.type_compare));
                        }
                    }
                }else {
                    data.addColumn('number', 'Telefon');
                }

                data.addRows(Object.keys(this.statistics).length);

                Object.keys(this.statistics).forEach( key => {
                    data.setValue(this.statistics[key].lfd, 0, this.statistics[key].show_date);
                    data.setValue(this.statistics[key].lfd, 1, Number(this.statistics[key].telefon));
                    if(this.compare){
                        data.setValue(this.statistics[key].lfd, 2, Number(this.statistics[key].telefon_compare));
                    }
                });

                const chart = new GoogleCharts.api.charts.Line(this.$refs.telefon);
                chart.draw(data, {
                    title: 'Telefon',
                    height: 400,
                    hAxis: {
                        title: 'Zeit'
                    },
                    vAxis: {
                        title: 'Telefon'
                    },
                });
                GoogleCharts.api.visualization.events.addListener(chart, 'ready', () => {
                    this.telefon_loading = false;
                });
            }
        },
        mounted() {
            this.fetchChartData();
        }
    }
</script>

<style scoped>
svg *{
  pointer-events: none;
}
</style>
